// src/Redux/slices/healthBotSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { hbGetToken, hbRefreshToken, hbEnsureToken } from "../thunks/healthBotThunks";

const initialState = {
    token: null,
    expiresAt: 0,
    directLineEndpoint: null,
    userId: null,
    lastReissuedAt: null,
    status: "idle", // 'idle' | 'loading' | 'ready' | 'error'
    error: null,
};

const healthBotSlice = createSlice({
    name: "healthBot",
    initialState,
    reducers: {
        hbReset(state) {
            state.token = null;
            state.expiresAt = 0;
            state.directLineEndpoint = null;
            state.userId = null;
            state.lastReissuedAt = null;
            state.status = "idle";
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // get token
            .addCase(hbGetToken.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(hbGetToken.fulfilled, (state, action) => {
                state.status = "ready";
                state.token = action.payload.token;
                state.expiresAt = action.payload.expiresAt;
                state.directLineEndpoint = action.payload.directLineEndpoint ?? null;
                state.userId = action.payload.userId ?? state.userId;
            })
            .addCase(hbGetToken.rejected, (state, action) => {
                state.status = "error";
                state.error = action.payload || "token_error";
            })

            // refresh token
            .addCase(hbRefreshToken.fulfilled, (state, action) => {
                state.token = action.payload.token;
                state.expiresAt = action.payload.expiresAt;
                if (action.payload.directLineEndpoint) {
                    state.directLineEndpoint = action.payload.directLineEndpoint;
                }
                if (action.payload.reissued) {
                    state.lastReissuedAt = Date.now();
                    state.status = "ready"; // still healthy
                }
            })
            .addCase(hbRefreshToken.rejected, (state, action) => {
                state.status = "error";
                state.error = action.payload || "refresh_error";
            })

            // ensure
            .addCase(hbEnsureToken.pending, (state) => {
                if (!state.token) state.status = "loading";
            })
            .addCase(hbEnsureToken.fulfilled, (state, action) => {
                if (action.payload?.token) {
                    state.token = action.payload.token;
                    state.expiresAt = action.payload.expiresAt ?? state.expiresAt;
                    if (action.payload.directLineEndpoint) {
                        state.directLineEndpoint = action.payload.directLineEndpoint;
                    }
                    state.status = "ready";
                    state.error = null;
                }
            })
            .addCase(hbEnsureToken.rejected, (state, action) => {
                state.status = "error";
                state.error = action.payload || "ensure_error";
            });
    },
});

export const { hbReset } = healthBotSlice.actions;
export default healthBotSlice.reducer;